import { formatISO9075 } from 'date-fns/formatISO9075';

import {
  CampaignMediaTypes,
  CampaignStatuses,
  CampaignFormats,
  CampaignTypes,
} from '@features/campaigns/shared/types/campaign';
import { AccessRights, AdManagerApiResponse } from '@shared/api/commonApiInterfaces';
import { UserCountryCodes } from '@shared/types/countryCodes.ts';
import { Campaign } from '@shared/utils/interfaces/campaign';

const mockedAdvertiser = {
  id: 'ccff7517-f89e-48e8-aca2-d06d34df298a',
  name: 'Advertiser #3',
};

export const mockedCampaignsList: AdManagerApiResponse<Campaign[]> = {
  items: [
    {
      id: 'ee164aa2-aec9-4423-8000-cae154f772e6',
      name: 'Campaign 1',
      startDate: formatISO9075(new Date(), { representation: 'date' }),
      endDate: formatISO9075(new Date(), { representation: 'date' }),
      status: CampaignStatuses.DRAFT,
      sequentialId: 1234,
      budget: 100000,
      format: [CampaignFormats.DISPLAY],
      accessRights: [AccessRights.EDIT_ALL, AccessRights.READ],
      billingSequentialId: 123,
      creatorName: 'John Web',
      mediaType: CampaignMediaTypes.CROSS,
      type: CampaignTypes.INTERNAL,
      country: UserCountryCodes.IT,
      advertiser: mockedAdvertiser,
    },
    {
      id: 'fe164aa2-aec9-4423-8000-cae154f772e6',
      name: 'Campaign 2',
      startDate: formatISO9075(new Date(), { representation: 'date' }),
      endDate: formatISO9075(new Date(), { representation: 'date' }),
      status: CampaignStatuses.APPROVED,
      sequentialId: 1235,
      budget: 1000,
      format: [CampaignFormats.VIDEO],
      accessRights: [AccessRights.APPROVE, AccessRights.EDIT_ALL, AccessRights.READ],
      billingSequentialId: 124,
      creatorName: 'Collin Barrell',
      mediaType: CampaignMediaTypes.CROSS,
      type: CampaignTypes.INTERNAL,
      country: UserCountryCodes.ES,
      advertiser: mockedAdvertiser,
    },
    {
      id: 'ge164aa2-aec9-4423-8000-cae154f772e6',
      name: 'Campaign 3',
      startDate: formatISO9075(new Date(), { representation: 'date' }),
      endDate: formatISO9075(new Date(), { representation: 'date' }),
      status: CampaignStatuses.BUDGET_APPROVAL,
      sequentialId: 1236,
      budget: 10020,
      format: [CampaignFormats.VIDEO, CampaignFormats.DISPLAY],
      accessRights: [],
      billingSequentialId: 125,
      creatorName: 'Gerard Debug',
      mediaType: CampaignMediaTypes.CROSS,
      type: CampaignTypes.INTERNAL,
      country: UserCountryCodes.IT,
      advertiser: mockedAdvertiser,
    },
  ],
  meta: { totalItems: 3, itemCount: 3, itemsPerPage: 10, totalPages: 1, currentPage: 1 },
};
